import { withInstall } from 'framework/utils'
import minMaxRangeInput from './src/MinMaxRangeInput.vue'
import { useComponentRegister } from 'framework/components/Form/index'
// 将admin的component注入到 framenwork的Form组件中
;[['MinMaxRangeInput', minMaxRangeInput]].forEach(([name, comp]) => {
  useComponentRegister(name as any, comp)
})

export const MinMaxRangeInput = withInstall(minMaxRangeInput)
